module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0719-min.e48fbe0b.jpg";